import { render, staticRenderFns } from "./TextEditorWithMetadata.vue?vue&type=template&id=d99ce64c"
import script from "./TextEditorWithMetadata.vue?vue&type=script&lang=js"
export * from "./TextEditorWithMetadata.vue?vue&type=script&lang=js"
import style0 from "./TextEditorWithMetadata.vue?vue&type=style&index=0&id=d99ce64c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports